import { AxiosResponse } from 'axios';
import { FBaseService, ResponseEnvelope } from '@kasasa/fbase-components/lib';

export interface SiteMapWrapper {
	draft: RawSiteMap[];
	live: RawSiteMap[];
	archive: RawSiteMap[];
}

export interface RawSiteMap {
	id: number;
	name: string;
	fkSiteMapType: string;
	children: RawSiteMap[];
}

export default class SiteMapService extends FBaseService {
	find(clientId: string, siteId: string): Promise<AxiosResponse<ResponseEnvelope<SiteMapWrapper>>> {
		return this.apiClient.get(`/api/kcms-sitemap/${clientId}/site/${siteId}`);
	}
}
